import {DomainAncestor, entityConfig} from "../../../core/common/domain/DomainAncestor";
import {observable} from "mobx";
import {ID} from "../../../core/metamodel/metaConstant";
import {SubCriterionParameter} from "../criterion/subCriterionParameterDomain";
import {ProjectVersion} from "./projectVersionDomain";

@entityConfig()
export class ProjectVersionParamValue extends DomainAncestor {

  @observable valueId: number;
  @observable paramNumber: number;
  @observable value: string;
  @observable projectVersion : ProjectVersion
  @observable parameter : SubCriterionParameter
  @observable count: number;

  constructor(json: any) {
    super(json);
  }

  public getId(): ID {
    return this.valueId;
  }

  public setId(id: ID): void {
    this.valueId = <number>id;
  }
}



// WEBPACK FOOTER //
// ./src/sbtool/domain/project/projectVersionParameterValueDomain.ts